import React from 'react';
import properties from '../../../constants/Properties';
import { AudioTrack } from '../menus/AudioTrack';
import audioEditorUtils from '../utils/AudioEditorUtils';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import locales from '../../../locales/LocalesManager';

export const AudioElement = React.createClass({
    getTrackTitle() {
        if (this.props.timeline.title && this.props.timeline.title.length > 0)
            return this.props.timeline.title;
        else {
            var title = locales.getCaption('track_1', 'other');

            if (title == undefined || title == '' || title.indexOf('other.') != -1)
                title = 'Track ' + (this.props.index + 1);
            else {
                title = title.replace('1', '');
                title = title + (this.props.index + 1);
            }

            return title;
        }
    },
    render() {
        var height = audioToolUtils.timelineHeight();
        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: this.props.index * height,
            left: 0,
            width: this.props.width,
            height
        };

        var lineSize = properties.LINE_SIZE;
        const topLineStyle = {
            position: 'absolute',
            width: menuStyle.width,
            left: 0,
            top: 0,
            height: lineSize,
            background: properties.AUDIO_BORDER
        };

        var bottomLine;
        var timelinesLength = audioEditorUtils.getTimelinesLength();
        var maxTimelines = audioEditorUtils.getMaxTimelinesRelatedToHeight();

        if (maxTimelines < timelinesLength)
            timelinesLength = maxTimelines;

        if ((this.props.index + 1) == timelinesLength) {
            const bottomLineStyle = {
                position: 'absolute',
                width: menuStyle.width,
                left: 0,
                top: height,
                height: lineSize,
                background: properties.AUDIO_BORDER
            };

            bottomLine = <div style={bottomLineStyle} />;
        }

        return (
            <div style={menuStyle} aria-label={this.getTrackTitle()}>
                <AudioTrack buttonsHolderWidth={this.props.buttonsHolderWidth} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} isMute={this.props.timeline.isMute} isSelected={this.props.timeline.isSelected} trackWidth={this.props.width} index={this.props.index} audios={this.props.timeline.audios} trackTitle={this.props.timeline.title} timelinesLength={timelinesLength} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch}/>
                <div style={topLineStyle} />
                {bottomLine}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioElement.js
 **/